import { Component, EventEmitter, OnInit, Input, Output, ViewChild,forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//components
import {EmployeeDropdownComponent} from '../../components/Employees/EmployeeDropdown.component';
import {SalesOfficeDropdownComponent} from '../../components/DomainData/SalesOfficeDropdown.component';


//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseControlGroupComponent }         from '../../baseclasses/BaseControlGroup.component';

@Component({
  selector: 'my-userinfo',
  templateUrl: './UserInfo.component.html',
  providers: [{provide: BaseControlGroupComponent, useExisting: forwardRef(() => UserInfoComponent)}]
})
export class UserInfoComponent extends BaseControlGroupComponent {

    @ViewChild(EmployeeDropdownComponent) public employeeDropdownComponent: EmployeeDropdownComponent;
    @ViewChild(SalesOfficeDropdownComponent) public salesOfficeDropdownComponent: SalesOfficeDropdownComponent;

    @Output() public onSalesOfficeChange: EventEmitter<ent.SalesOffice> = new EventEmitter();

    @Input() public showCustomerNumber: boolean;
    
    userInfo: ent.UserInfo;
    public request: ent.Request;

    userInfoForm: FormGroup;

    setDates(){}

    setRequestInfo(request: ent.Request){
        this.salesOfficeDropdownComponent.selectedID = request.SalesOfficeID;
        this.userInfo.Employee.ID = request.EmployeeID;
        this.request = request;
        //Note: the below call to loadEmployeePhoneNumber is needed to support the scenario where the user responds "yes" to the prompt of whether to set the 
        //employee phone number to the request phone number. In this scenario, the phone number stored in the userInfo local setting/cookie will not be refreshed
        //and needs to be updated.
        this.loadEmployeePhoneNumber();
        //this.employeeDropdownComponent.value = request.EmployeeID;
        //console.info("UserInfo.setRequestInfo: request.EmployeeID: " + request.EmployeeID);
    }

    constructor(fb: FormBuilder) 
    { 
        super();
        this.request = new ent.Request();
        let group = {
          'salesOffice' : '',
        //   'salesRepName' : '',
          'requestor' : '',
          'requestorName' : { value: '', disabled: "true" },
          'requestorPersonnelNumber' : { value: '', disabled: "true" },
          'requestorPhoneNumber' : { value: '', disabled: "true" },
          'requestPhoneNumber' : ''
        };
        
        this.userInfoForm = fb.group(group);


    }

    loadEmployeePhoneNumber(){
        var filter: filters.EmployeeFilter = {EmployeeID: this.userInfo.Employee.ID};
        this.employeeService.getEmployees(filter).subscribe(x=> {
            if (x.length > 0){
                this.userInfo.Employee.PhoneNumber = x[0].PhoneNumber;
                if (!this.request.PhoneNumber){
                    this.request.PhoneNumber = this.userInfo.Employee.PhoneNumber;
                }
            }
        });
    }
    employeeDropdownLoadDone(){
        if (this.employeeDropdownComponent){
            this.employeeDropdownComponent.value = this.userInfo.Employee.ID;
        }
        
        //console.info("UserInfo.employeeDropdownLoadDone: this.employeeDropdownComponent.value: " + this.employeeDropdownComponent.value);
    }

    ngOnInit(): void {
        
        this.userInfo = this.authenticationService.getUserInfo();
        if (this.employeeDropdownComponent){
            this.employeeDropdownComponent.loadDone.subscribe((x: any) => this.employeeDropdownLoadDone());
        }

        if (!this.request.PhoneNumber){
            this.request.PhoneNumber = this.userInfo.Employee.PhoneNumber;
        }
        this.loadEmployeePhoneNumber();

       

        this.userInfoForm.controls.requestPhoneNumber.setValidators(Validators.required);
    }

    requestorChange(event: any){
        this.userInfo.Employee.ID = event;
        var matchingEmployees = this.employeeDropdownComponent.employees.filter(x=>x.ID == event);
        if (matchingEmployees && matchingEmployees.length > 0){
            this.userInfo.Employee.FullName = matchingEmployees[0].FullName;
            this.userInfo.Employee.PersonnelNumber = matchingEmployees[0].PersonnelNumber;
            this.userInfo.Employee.PhoneNumber = matchingEmployees[0].PhoneNumber;
            if (!this.request.PhoneNumber){
                this.request.PhoneNumber = matchingEmployees[0].PhoneNumber;
            }
        }
    }

    salesOfficeChange(event: any){
        this.userInfo.SalesOffice.ID = event;
        var salesOffice: ent.SalesOffice;
        var crossDock: ent.SalesOffice = new ent.SalesOffice();
        var matches = this.salesOfficeDropdownComponent.salesOffices.filter(x=>x.ID == event);
        if (matches.length > 0){
            salesOffice = matches[0];
            var crossDocks = this.salesOfficeDropdownComponent.salesOffices.filter(x=>x.ID == salesOffice.CrossDockSalesOfficeID);
            if (crossDocks.length > 0){
                crossDock = crossDocks[0];
            }
        }
        
        this.onSalesOfficeChange.emit(salesOffice);
        
    }
}